<template>

    <div class="flex flex-col lg:flex-row" data-scroll-target="faq">
        <div class="w-full lg:w-1/3 bg-hh-cyan-50">
            <div class="faq-toggle-container">
                <div
                    class="faq-toggle"
                    :class="{ 'active' : faqCategory.active }"
                    v-for="faqCategory in faqCategories"
                    @click.prevent="activateCategory(faqCategory)"
                >
                    {{ faqCategory.name }}
                </div>

                <div class="block lg:hidden text-center my-4 lg:my-0">
                    <button
                        type="button"
                        class="blue-pill"
                        @click="closeFaqMenu"
                        v-html="translations.close"
                    ></button>
                </div>

                <div class="hidden lg:block p-4 px-5">
                    <p v-html="translations['question-text']"></p>
                    <a :href="contactUrl" class="button orange cta rounded-r" v-html="translations['question-button']"></a>
                </div>
            </div>
        </div>

        <div class="w-full lg:w-2/3 lg:ml-4 pb-8 bg-hh-grey-50 lg:rounded-bl-5xl">
            <div
                class="faq-category"
                :class="{ 'active' : faqCategory.active }"
                v-for="faqCategory in faqCategories"
            >
                <faq-category
                    :category-data="faqCategories"
                    :question-data="faqCategory.questions"
                    :category-ref="faqCategory.slug"
                    :category-name="faqCategory.name"
                    :ref="'category-' + faqCategory.slug"
                >
                </faq-category>

            </div>

            <div class="p-8 lg:hidden">

                <div class="mb-4 font-medium">{{ translations['more-faq'] }}:<br></div>

                <template v-for="faqCategory in faqCategories">
                <div
                    class="faq-pill"
                    @click.prevent="activateCategory(faqCategory)"
                    v-if="! faqCategory.active"
                >
                    {{ faqCategory.name }}
                </div>
                </template>
            </div>

        </div>
    </div>

</template>

<script>

import FaqCategory from './FaqCategory.vue';
import ScrollsToTarget from "../../../Mixins/ScrollsToTarget.js";

export default {

    name: "FaqFull",

    components: {
        'faq-category': FaqCategory,
    },

    mixins: [ScrollsToTarget],

    props: ['faqData', 'contactUrl', 'textQuestion', 'textButton', 'translations', 'hasActiveCategory'],

    data() {
        return {
            faqCategories: null,
        }
    },

    created() {
        this.faqCategories = this.faqData;
    },

    mounted() {
        this.Bus.on('activate-category', (reference) => {
            this.activateCategory(reference);
        });

        if (this.hasActiveCategory) {
            let target = document.querySelector('div[data-scroll-target="faq"]');

            if (target) {
                this.scrollTo(target.offsetTop - 32, 300);
            }
        }
    },

    methods: {
        activateCategory: function (faqCategory) {

            this.faqCategories.map((targetFaqCategory) => {
                targetFaqCategory.active = false;
            });

            history.pushState(null, null, faqCategory.url);

            faqCategory.active = true;

            this.Bus.emit('open-category', faqCategory.slug);

            this.closeFaqMenu();
        },

        closeFaqMenu() {
            let body = document.getElementsByTagName('body')[0];
            body.classList.remove('with-faq-menu');
        },
    }
}
</script>

<style scoped>

</style>
